module.exports = new __parcel__URL__("plato.bc1c213d.png").toString();